import { TASK_REQUEST_SKELETON_ROWS } from '@/features/task-assignment/config/taskAssignment';
import { Skeleton } from '@/shared/components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/shared/components/ui/table';

/** Route-level pending shape matching the task-request table and its filters. */
export function TaskAssignmentListSkeleton() {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-hidden p-4 md:p-6">
      <div className="mx-auto flex min-h-0 w-full max-w-6xl flex-1 flex-col gap-4">
        <div className="flex shrink-0 items-start justify-between gap-4 border-b pb-4">
          <div className="space-y-2">
            <Skeleton className="h-6 w-40" />
            <Skeleton className="h-4 w-80 max-w-full" />
          </div>
          <Skeleton className="h-8 w-24 rounded-md" />
        </div>

        <div className="scrollbar-hide flex items-center gap-2 overflow-x-auto rounded-md border p-3">
          <Skeleton className="h-8 w-72 shrink-0 rounded-md" />
          <Skeleton className="h-8 w-52 shrink-0 rounded-md" />
          <Skeleton className="h-8 w-48 shrink-0 rounded-md" />
        </div>

        <div className="rounded-md border bg-background">
          <Table className="min-w-[1104px] table-fixed text-xs">
            <TableHeader>
              <TableRow className="hover:bg-transparent">
                <TableHead className="h-8 w-auto p-1.5">
                  <Skeleton className="h-3 w-12" />
                </TableHead>
                <TableHead className="h-8 w-64 p-1.5">
                  <Skeleton className="h-3 w-14" />
                </TableHead>
                <TableHead className="h-8 w-36 p-1.5">
                  <Skeleton className="h-3 w-16" />
                </TableHead>
                <TableHead className="h-8 w-24 p-1.5">
                  <Skeleton className="h-3 w-12" />
                </TableHead>
                <TableHead className="h-8 w-40 p-1.5">
                  <Skeleton className="h-3 w-14" />
                </TableHead>
                <TableHead className="h-8 w-44 p-1.5">
                  <Skeleton className="h-3 w-14" />
                </TableHead>
                <TableHead className="h-8 w-8 p-1.5" />
              </TableRow>
            </TableHeader>
            <TableBody>
              {Array.from({ length: TASK_REQUEST_SKELETON_ROWS }, (_, index) => index).map(
                (index) => (
                  <TableRow key={index} className="hover:bg-transparent">
                    <TableCell className="h-12 space-y-1.5 p-1.5">
                      <Skeleton className="h-3 w-3/4" />
                      <Skeleton className="h-2.5 w-1/2" />
                    </TableCell>
                    <TableCell className="h-12 p-1.5">
                      <Skeleton className="h-3 w-24" />
                    </TableCell>
                    <TableCell className="h-12 p-1.5">
                      <Skeleton className="h-4 w-24" />
                    </TableCell>
                    <TableCell className="h-12 p-1.5">
                      <Skeleton className="h-4 w-16" />
                    </TableCell>
                    <TableCell className="h-12 p-1.5">
                      <div className="flex items-center gap-2">
                        <Skeleton className="size-6 shrink-0 rounded-full" />
                        <Skeleton className="h-3 w-20" />
                      </div>
                    </TableCell>
                    <TableCell className="h-12 space-y-1.5 p-1.5">
                      <Skeleton className="h-3 w-28" />
                      <Skeleton className="h-2.5 w-20" />
                    </TableCell>
                    <TableCell className="h-12 w-8 p-1.5" />
                  </TableRow>
                ),
              )}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
